import { render } from "./TheSecondaryMenu.vue?vue&type=template&id=0735bf08&scoped=true&ts=true"
import script from "./TheSecondaryMenu.vue?vue&type=script&lang=ts"
export * from "./TheSecondaryMenu.vue?vue&type=script&lang=ts"

import "./TheSecondaryMenu.vue?vue&type=style&index=0&id=0735bf08&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0735bf08"]])

export default __exports__